import RadarChartCard from "@/pages/dashboard/pages/benchmark/components/RadarChartCard";
import CompetitorTable from "@/pages/dashboard/pages/benchmark/components/CompetitorTable";
import RadarChartCardTitle from "@/pages/dashboard/pages/benchmark/components/RadarChartCardTitle";
import RadarChartCardService from "@/pages/dashboard/pages/benchmark/components/RadarChartCardService";
import DbdBenchmarkFilter from "@/pages/dashboard/filterPageComponents/benchmark/BenchmarkFilter";
import GTDRAssessmentFilter from "@/pages/dashboard/filterPageComponents/benchmark/GTDRAssessmentFilter";
import GTDRTableCard from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRTableCard";
import GTDRCommonService from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRCommonService";
import GTDRRadarChart from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRRadarChart";
import GTDRSummaryCard from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/SummaryCard";
import GTDRSummaryService from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/SummaryCard/SummaryService";
import GTDRRiskLevelService from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRRiskLevelService";
import GTDRRiskLevel from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRRiskLevel";
import StudioAssessmentFilter from "@/pages/dashboard/filterPageComponents/benchmark/StudioAssessmentFilter";
import GTDROverview from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDROverview";

export default {
  DbdBenchmarkFilter,
  RadarChartCard,
  RadarChartCardTitle,
  RadarChartCardService,
  CompetitorTable,
  GTDRAssessmentFilter,
  GTDRTableCard,
  GTDRCommonService,
  GTDRRadarChart,
  GTDRSummaryCard,
  GTDRSummaryService,
  GTDRRiskLevelService,
  GTDRRiskLevel,
  StudioAssessmentFilter,
  GTDROverview
};